import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

const steps = [
	{
		id: 1,
		titleResourceKey: 'FO_RegistrationSteps_Parent',
		columns: 3
	},
	{
		id: 2,
		titleResourceKey: 'FO_RegistrationSteps_Child',
		columns: 2
	},
	{
		id: 3,
		titleResourceKey: 'FO_RegistrationSteps_Center',
		columns: 2
	},
	{
		id: 4,
		titleResourceKey: 'FO_RegistrationSteps_Class',
		columns: 2
	},
	{
		id: 5,
		titleResourceKey: 'FO_RegistrationSteps_Confirm',
		columns: 3
	}];

const RegistrationSteps = ({ currentStep, t }) => {
	return (
		<Row className='show-grid'>
			<div className='register-steps'>
				{steps.map(step => {
					const isActiveStep = Number(currentStep) === step.id;

					return <Col key={step.id} xs={step.columns} className={'steps_s ' + `step${step.id}` + (currentStep < step.id ? ' disabled' : '')}>
						<span className={`title ${isActiveStep ? 'active' : ''}`}>{t(step.titleResourceKey)}</span>
					</Col>;
				})}
				<div className='clearfix' />
			</div>
		</Row >
	);
};

export default withTranslation()(RegistrationSteps);